import { Injectable } from "@angular/core";
import { Validators } from "@angular/forms";
import { BaseControl, Container, TextArea, Textbox } from "@app/shared/dynamic-form";

@Injectable()
export class ReassigmentFormService{

  constructor(){}

  getField(objectModel?: any): BaseControl<any>[]{
    const controls: BaseControl<any>[] = [
      new Container({
        class: 'form-row',
        order: 1,
        controls: [
          new Textbox({
            key: 'textbox',
            label: 'Asunto:',
            size: 'col-12 col-lg-12',
            placeholder: 'Ingrese el asunto de reasignación',
            disabled: false,
          }),
          new TextArea({
            key: 'textarea',
            label: 'Descripción:',
            size: 'col-12 col-lg-12',
            placeholder: 'Describa el motivo de la reasignación',
            notResize: true,
            value: objectModel ? objectModel.textarea : null,
          }),
        ]
      })
    ];
    return controls.sort((a, b) => a.order - b.order);
  }
}


// WEBPACK FOOTER //
// ./src/app/shared/reassigment-responsibles/shared/reassigment-form.service.ts